import { render, staticRenderFns } from "./Maincard.vue?vue&type=template&id=ae35e170&scoped=true"
import script from "./Maincard.vue?vue&type=script&lang=js"
export * from "./Maincard.vue?vue&type=script&lang=js"
import style0 from "./Maincard.vue?vue&type=style&index=0&id=ae35e170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae35e170",
  null
  
)

export default component.exports